import { Language } from '../interfaces';

type Props = {
    pageTable: {
        [lang: string]: string;
    };
    language: Language;
    withDefaultTag: boolean;
};

export type PageMetadata = {
    canonicalUrl: string;
    alternates: {
        href: string;
        hrefLang: string;
    }[];
};

const getHrefLang = (language: Language) => {
    return language === 'en' ? 'en-gb' : 'nb-no';
};

export const getMetadataFromPageTable = ({ pageTable, language, withDefaultTag }: Props) => {
    const pageUrl = process.env.GATSBY_STOREFRONT_URL;

    const pagePath = pageTable[language];
    const englishPath = pageTable['en'];

    const xDefaultTag = {
        href: `${pageUrl}${englishPath || pagePath}`,
        hrefLang: 'x-default',
    };

    const currentPage = pageTable[language];
    const alternates =
        Object.keys(pageTable).map(key => {
            return {
                href: `${pageUrl}${pageTable[key]}`,
                hrefLang: getHrefLang(key as Language),
            };
        }) || [];

    return {
        canonicalUrl: currentPage ? `${pageUrl}${currentPage}` : `${pageUrl}/en`,
        alternates: withDefaultTag ? [xDefaultTag, ...alternates] : alternates,
    } as PageMetadata;
};
